import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { baseUrl, PendingStudentError, RejectedStudentError } from "../Utility/constants";
import MainHeader from "./common/MainHeader";
import { FooterName } from "../Utility/constants";
import useSchoolData from "../hooks/useSchoolData";

const Login = () => {
  const {
    schoolInfo,
    schoolContactInfo,
    schoolId,
    loading
  } = useSchoolData();

  const [aadhaarCardNumber, setAadhaarCardNumber] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const standardApiUrl = `${baseUrl}/api/StandardMaster/GetStandardBySchool`;
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  useEffect(() => {
    // Clear user data from local storage
    localStorage.removeItem("userEmail");
    localStorage.removeItem("Role");
    localStorage.removeItem("userID");
    localStorage.removeItem("AccessToken");
  }, []);

  const handleLogin = async () => {
    if (isLoggingIn) return; // Prevent double click

    setIsLoggingIn(true);

    try {
      const response = await axios.post(`${baseUrl}/api/Users/Login`, {
        AadhaarCardNumber: aadhaarCardNumber,
        password: password,
      });

      if (!response || !response.data) {
        throw new Error("Invalid response");
      }
      if (response.data && response.data.status === 'PENDING' || response.data.status === 'REJECTED') {
        toast.error(response.data.status === 'PENDING' ? PendingStudentError : RejectedStudentError);
      }
      else if (response.data && response.data.user) {
        localStorage.setItem("Role", response.data.user.role);
        localStorage.setItem("userEmail", response.data.user.email);
        localStorage.setItem("userID", response.data.user.id);
        localStorage.setItem("IsClassTeacher", response.data.user.isClassTeacher);
        const loggedUser = response.data.user.role;
        localStorage.setItem("loggedUserFullName", response.data.user.name);
        localStorage.setItem("loggedInUserId", response.data.user.loggedUserId);
        if (loggedUser === "SUPERADMIN") {
          navigate("/superadmindashboard");
        } else if (loggedUser === "ADMIN") {
          navigate("/admindashboard");
        } else if (loggedUser === "STUDENT") {
          navigate("/manage-personal-student");
        } else if (loggedUser === "RECEPTIONIST") {
          navigate("/manage-reception-dashboard");
        } else if (loggedUser === "TEACHER") {
          navigate("/teachers-landing");
        } else if (loggedUser === "EXAMHEAD") {
          navigate("/examhead-landing");
        }

      } else {
        toast.error(response.data.statusMessage);
      }
    } catch (error) {
      console.error("Login error:", error);

      if (error?.response?.data) {
        toast.error(error.response.data);
      } else {
        toast.error("Invalid user. Please check the credentials or contact administrator.");
      }
    } finally {
      setIsLoggingIn(false);
    }
  };


  return (
    <div>
      <MainHeader orgname={schoolInfo?.schoolOrCollegeName} />
      <div className="container mt-5">
        {/* Hero Section */}
        {(schoolInfo?.organizationName && schoolContactInfo?.city) &&
          <div className="text-center mb-5">
            <h4>Welcome to {schoolInfo?.organizationName} (Since {schoolInfo?.establishmentYear})</h4>
            <h2>
              {schoolInfo?.schoolOrCollegeName}, {schoolContactInfo?.city},
              Tal.{schoolContactInfo?.taluka}, Dist.{schoolContactInfo?.district}
              -{schoolContactInfo?.pincode}
            </h2>
          </div>
        }

        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card">
              <div className="card-header">
                <>
                  <strong>Login for the Academic Year - </strong>
                  <span className="text-success fw-bold">{schoolInfo?.currentSession}</span>
                </>

              </div>
              <div className="card-body">
                <form>
                  <div className="mb-3">
                    <label htmlFor="aadhaarCardNumber" className="form-label">
                      Enter Aadhaar No
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="aadhaarCardNumber"
                      value={aadhaarCardNumber}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {   // allows only digits
                          setAadhaarCardNumber(e.target.value);
                        }
                      }}
                      maxLength={12}
                      minLength={12}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">
                      Password
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      id="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  {/* <button
                    type="button"
                    className="btn btn-primary me-2"
                    onClick={handleLogin}
                  >
                    Login
                  </button> */}
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    onClick={handleLogin}
                    disabled={isLoggingIn}
                  >
                    {isLoggingIn ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Logging in...
                      </>
                    ) : (
                      "Login"
                    )}
                  </button>
                  <Link
                    to="/registration"
                    className={`btn btn-secondary ${isLoggingIn ? "disabled" : ""}`}
                    onClick={(e) => isLoggingIn && e.preventDefault()}
                  >
                    Registration
                  </Link>
                  {/* <Link to="/registration" className="btn btn-secondary">
                    Registration
                  </Link> */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div >
      <footer
        className="fixed-bottom"
        style={{
          backgroundColor: "black",
          color: "#6c757d",
          textAlign: "center",
          padding: "10px 0",
          boxShadow: "0 -1px 5px rgba(0, 0, 0, 0.1)",
          width: "100%",
        }}
      >
        <div className="container">
          <p className="mb-0" style={{ color: "white" }}>
            Copyright &copy; 2017-{currentYear} {FooterName} | All rights
            reserved.
          </p>
        </div>
      </footer>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar
        newestOnTop
        closeOnClick
        rtl
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ width: "35%" }}
      />
    </div >
  );
};

export default Login;
